$(function () {
    var $field = $('#jobZip');
    if (!$field.length) return;

    $.ajax({
        url: '/wp-admin/admin-ajax.php',
        data: { action: 'get_user_city_state' },
        type: 'POST',
        success: function (response) {
            if (response.success && response.data.location && !$field.val()) {
                $field.val(response.data.location);
            }
        }
    });
});
